// import local dependencies
import Router from './util/router';
import common from './routes/Common';
import home from './routes/Home';
import {
  default as singleRniNews,
  default as pageTemplatePageLandingPage,
} from './routes/Single';
import {
  default as singleBnuProduct,
  default as singleIpA80694dc7afe3f60,
} from './routes/SingleProduct';
import {
  default as pageTemplatePageJobsOverview,
} from './routes/JobArchive';

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
const routes = {
  common,
  home,
  singleBnuProduct,
  singleIpA80694dc7afe3f60,
  singleRniNews,
  pageTemplatePageLandingPage,
  pageTemplatePageJobsOverview,
};

// Load Events
document.addEventListener("DOMContentLoaded", function() {
  new Router(routes).loadEvents();
});

/**
 * Polyfills
 */
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;

}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
